/* eslint-disable import/newline-after-import */
/* eslint-disable semi-style */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { render } from 'react-dom'
import Root from './components/Root/Root'

import {
  APIClient,
  getCockpitCookie,
  dispatchDeleteAllTokensEvent,
  listenFirebaseRemoveTokenEvent,
  deleteTokenOnFirebaseWithEvent
} from './index'

// Imediatelly inject `CockpitNotifications` on browser's global namespace
;((globalObject) => {
  // prettier-disable
  const CDN = {}

  const { document: globalDocument } = globalObject

  // This is the GLOBAL namespace that will be exported to the main browser's context
  //  eg: `window.CockpitNotifications`
  const COCKPIT_NOTIFICATIONS_NAMESPACE = 'CockpitNotifications'

  // The current rendered DOM element rendered (it's populate after calling \`mount\` function)
  CDN.__currrentElement = null

  // Export helpers functions from the main library to be used in the browser
  // eg: helpers.getCockpitToken()
  CDN.helpers = {
    getCockpitCookie,
    dispatchDeleteAllTokensEvent,
    listenFirebaseRemoveTokenEvent,
    deleteTokenOnFirebaseWithEvent
  }

  // Allow developers to programmatically interact's with CDN HTTP API using an plain javascript API
  // eg:
  // var apiClient = new CockpitNotifications.APIClient('https://some-host.com', 'some-token')
  // apiClient.getProducts() // Dispatch a `GET /v1/products` request
  CDN.APIClient = APIClient

  // Mount and render the main "Cockpit Notifications" component on Browser's DOM
  CDN.mount = (element, props = {}) => {
    // Check either the received `element` is a valid HTMLDOM to be used
    // eslint-disable-next-line operator-linebreak
    const isGlobalDocument =
      globalDocument === element || globalDocument.body === element
    const forbiddenMount = isGlobalDocument || element === globalObject

    if (!element) {
      throw new Error(
        'You should provide a root DOM Element as first argument to mount "Cockpit Notifications"'
      )
    }

    if (forbiddenMount) {
      throw new Error(
        'You should NOT mount "Cockpit Notifications" directly on `document` or `document.body`'
      )
    }

    const renderResponse = render(<Root {...props} />, element)

    const { base = null } = renderResponse || {}

    // Fallcabk
    CDN.__currrentElement = base || element.firstChild
  }

  // Remove the current rendered component from the Browser's DOM tree
  CDN.unmount = () => {
    const { __currrentElement = null } = CDN

    if (__currrentElement) {
      __currrentElement.remove()

      CDN.__currrentElement = null
    }
  }

  // Outsider's should not be able to reconfigure `window.CockpitNotification` for security reasons
  Object.defineProperty(globalObject, COCKPIT_NOTIFICATIONS_NAMESPACE, {
    value: CDN,
    configurable: false,
    writable: false
  })
})(window)
